import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as MangadexIcon } from "./mangadex-logo.svg";

const Mangadex = (props: any) => {
  return (
    <SvgIcon component={ MangadexIcon } {...props} />
  );
}

export default Mangadex;